(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["klaviyo-form"] && !Shopify.designMode) return;
  try {
    
// console.log(26);

(function () {
  var MEDICAL_STATES = ['Ohio', 'Michigan', 'Pennsylvania', 'South Carolina'];

  var URLS = {
    medicalSafetyBeds: 'https://insurance.safeplacebedding.com/medical-safety-bed-insurance-form/',
    safePlacePermanentBed: 'https://insurance.safeplacebedding.com/',
    outOfStateInsurance: 'https://insurance.safeplacebedding.com/',
    outOfStateGrants: 'https://safeplacebedding.com/pages/nationwide-funding-grants-for-special-needs-beds',
    noInsurance: 'https://safeplacebedding.com/pages/list-of-grant-resources',
  };

  var MEDICAL_NEEDS_FIELD = 'Does your child have any of the following more complex medical needs while in bed?';
  var NONE_OF_THESE_LABEL = 'None of these';

  window.addEventListener('klaviyoForms', function (e) {
    var detail = e.detail;
    if (detail.type !== 'stepSubmit') return;

    var meta = detail.metaData || {};
    console.log(meta);

    var state = (meta['$state'] || meta['State'] || meta['Where are you located?'] || '').trim();
    var insurance = (meta['Do you have Medicaid or Commercial Insurance?'] || '').toLowerCase().trim();

    // Rule 1: No insurance → grant resources page
    if (insurance === 'no') {
      window.location.href = URLS.noInsurance;
      return;
    }

    var rawNeeds = meta[MEDICAL_NEEDS_FIELD];
    console.log(rawNeeds);
    if (!rawNeeds) return;

    var selectedNeeds = Array.isArray(rawNeeds) ? rawNeeds : [rawNeeds];

    var checkedComplexNeeds = selectedNeeds.some(function (val) {
      return val.trim() !== NONE_OF_THESE_LABEL;
    });

    // Rule 2: Any complex medical needs → Medical Safety Beds form (regardless of state)
    if (checkedComplexNeeds) {
      window.location.href = URLS.medicalSafetyBeds;
      return;
    }

    // Rule 3: "None of these" selected — now state matters
    var isQualifyingState = MEDICAL_STATES.some(function (s) {
      return s.toLowerCase() === state.toLowerCase();
    });

    if (isQualifyingState) {
      window.location.href = URLS.safePlacePermanentBed;
    } else {
      window.location.href = URLS.outOfStateInsurance;
    }
  });

})();





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
